import React from 'react';
import {
  Grid,
  Button,
  TextField,
  InputAdornment,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  StyledHeadContainer,
  StyledTitleAssignement,
  StyledButton,
  StyledSecondaryButton,
  StyledFieldSpacing,
  StyledSecondHeadContainer,
} from 'containers/AttributionManager/styles';
import SearchIcon from 'images/search.svg';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import deleteIcon from 'images/delete-icon.svg';

export interface AssignedManagerHeadProps {
  intl: IntlShape;
  title: string;
  setIsSelectedManagers: Function;
  isSelectedManagers: boolean;
  isAssignedManagers: boolean;
  handleOpenConfirmationDialog: Function;
  searchNameAssignedManager: string;
  sortAssignedManager: string;
  handleChangeSortAssignedManager: Function;
  handleChangeInputSearch: Function;
  isTransactionAttribution?: boolean;
}

export const AssignedManagerHead: React.FC<AssignedManagerHeadProps> = (
  props,
): JSX.Element => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    props.handleChangeInputSearch(e.target.value);
  };
  /* istanbul ignore next */
  const handleChangeSelect = (e: React.ChangeEvent<{ value: unknown }>) => {
    props.handleChangeSortAssignedManager(e.target.value);
  };
  return (
    <Grid
      item
      style={
        props.isTransactionAttribution
          ? StyledSecondHeadContainer
          : StyledHeadContainer
      }
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="space-between"
      >
        <Grid item>
          <span style={StyledTitleAssignement}>{props.title}</span>
        </Grid>
        {props.isSelectedManagers && (
          <Grid item xs={6}>
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item xs>
                <TextField
                  name="search-field"
                  value={props.searchNameAssignedManager}
                  label={translate(messages.searchField, props)}
                  onChange={handleChange}
                  style={StyledFieldSpacing}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <img src={SearchIcon} alt="search icon" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={props.isTransactionAttribution ? 5 : 6}>
                <FormControl
                  variant="standard"
                  style={{ width: '100%', marginTop: '-6px' }}
                >
                  <Select
                    value={props.sortAssignedManager}
                    onChange={handleChangeSelect}
                    defaultValue={'alphaOrder'}
                    style={{
                      width: '100%',
                      fontWeight: 700,
                    }}
                  >
                    <MenuItem value={'desc'}>
                      {translate(messages.busierTitle, props)}
                    </MenuItem>
                    <MenuItem value={'asc'}>
                      {translate(messages.lessBusyTitle, props)}
                    </MenuItem>
                    <MenuItem data-testId={'alphaOrder'} value={'alphaOrder'}>
                      {translate(messages.alphabeticalOrder, props)}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        )}
        {props.isSelectedManagers ? (
          <Grid item>
            <Button
              style={{ ...(StyledButton as any) }}
              data-testId={'select-button'}
              onClick={() => {
                props.setIsSelectedManagers(false);
              }}
            >
              <span> {translate(messages.selectButtonTitle, props)}</span>
            </Button>
          </Grid>
        ) : (
          <Grid item>
            <Grid container direction="row" alignItems="center" spacing={1}>
              <Grid item>
                <Button
                  style={{ ...(StyledButton as any) }}
                  data-testId={'cancel-select-button'}
                  onClick={() => {
                    props.setIsSelectedManagers(true);
                  }}
                >
                  <span>{translate(messages.cancelSelectionTitle, props)}</span>
                </Button>
              </Grid>
              <Grid item>
                <Button
                  style={{ ...(StyledSecondaryButton as any) }}
                  data-testId={'unassigned-button'}
                  onClick={() => {
                    props.handleOpenConfirmationDialog();
                  }}
                >
                  <Grid container direction="row" alignItems="center">
                    <Grid item>
                      <img
                        src={deleteIcon}
                        style={{ marginTop: '4px' }}
                        alt="delete icon"
                      />
                    </Grid>
                    <Grid item>
                      <span>
                        {translate(messages.unassignedButtonTitle, props)}
                      </span>
                    </Grid>
                  </Grid>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default injectIntl(AssignedManagerHead);
